module.exports = __webpack_public_path__ + "img/logos.8932dc96.png";